module.exports = __webpack_public_path__ + "h5/img/shuxingtu@3x.1dcbe63b.png";